module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-home u-pad-y-1",
    style: ({
      'overflow': _vm.isFakeScroll ? '' : 'hidden'
    })
  }, [_c('section', {
    staticClass: "c-landing u-fit-w u-relative u-viewport-fit-h"
  }, [_c('div', {
    staticClass: "u-absolute u-pos-tl u-fit"
  }, [_c('div', {
    staticClass: "js-background u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _c('app-carousel-3d', {
    attrs: {
      "content": _vm.carousel,
      "mouse-pos-smooth": _vm.mousePosSmooth
    },
    on: {
      "index-change": _vm._onCarousel3DIndexChange
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.games), function(game, index) {
    return _c('section', {
      key: index,
      staticClass: "c-video-game u-relative u-viewport-fit-h u-index-2",
      class: ['u-index-' + (index + 2)]
    }, [(!_vm.isFakeScroll) ? _c('div', {
      staticClass: "c-home-section u-absolute u-overflow-h"
    }, [_c('img', {
      staticClass: "c-home-section--bg u-absolute u-block js-bg-csgo",
      attrs: {
        "src": game.informations.cover,
        "alt": game.informations.name,
        "title": game.informations.name
      }
    })]) : _vm._e(), _vm._v(" "), (!_vm.isFakeScroll && !_vm.isMobile) ? _c('div', {
      staticClass: "u-absolute u-pos-tl u-fit"
    }, [_c('img', {
      staticClass: "u-absolute u-pos-center js-title-csgo",
      attrs: {
        "src": game.informations.logo_light,
        "alt": game.informations.name,
        "title": game.informations.name
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
      staticClass: "u-absolute u-flex--y u-fit u-pad-y-vh1of6 u-pos-tl u-flex--align-items--stretch"
    }, [_c('div', {
      staticClass: "u-relative u-flex__item--auto"
    }, [_c('img', {
      staticClass: "c-home-logo--mobile u-absolute u-pos-center",
      attrs: {
        "src": game.informations.logo_light,
        "alt": game.informations.name,
        "title": game.informations.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "u-relative u-flex__item--auto"
    }, [_c('app-btn-skew', {
      staticClass: "u-inline-block u-absolute u-pos-center",
      attrs: {
        "selected": true
      }
    }, [_c('app-hsm-link', {
      staticClass: "c-hsm-link--mobile",
      attrs: {
        "href": game.button_up.url,
        "prevent": false,
        "span-class": "t-text--md"
      }
    }, [_vm._v(_vm._s(game.button_up.label))]), _vm._v(" "), _c('app-hsm-link', {
      staticClass: "c-hsm-link--mobile",
      attrs: {
        "href": game.button_down.url,
        "prevent": false,
        "span-class": "t-text--md"
      }
    }, [_vm._v(_vm._s(game.button_down.label))])], 1)], 1)]) : _vm._e()])
  }), _vm._v(" "), _c('app-partners', {
    staticClass: "c-home-section--partners c-marg--before-footer",
    attrs: {
      "content-global": _vm.contentGlobal
    },
    on: {
      "load": _vm._onPartnersLoaded
    }
  }), _vm._v(" "), (_vm.isFakeScroll && !_vm.isMobile) ? _c('app-parallax', {
    staticClass: "u-absolute u-pos-tl u-viewport-fit u-pointer-none",
    attrs: {
      "velocity": 1
    }
  }, _vm._l((_vm.games), function(game, index) {
    return _c('transition', {
      key: index,
      attrs: {
        "name": "c-home__game-logo"
      }
    }, [(_vm.state === index) ? _c('h3', {
      staticClass: "c-home__game-logo u-absolute u-pos-center u-overflow-h",
      class: ['is-' + game.informations.slug]
    }, [_c('img', {
      staticClass: "c-home__game-logo__img u-absolute u-pos-tl",
      attrs: {
        "src": game.informations.sprite,
        "alt": game.informations.name,
        "title": game.informations.name
      }
    })]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-hsm"
    }
  }, [_c('app-hsm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMenuVisible && !_vm.isMobile),
      expression: "isMenuVisible && !isMobile"
    }],
    staticClass: "u-index-6",
    attrs: {
      "abs-to-top": 'translateY(-250px) translateY(100vh)',
      "state": _vm.state,
      "games": _vm.games,
      "content": _vm.nav
    },
    on: {
      "overgame": _vm._onOverGame,
      "outgames": _vm._onOutGames
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2443d34c"}!./src/scripts/components/page-home/template.html
// module id = 892
// module chunks = 0